import Link from "next/link";
import Image from "next/future/image";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row } from "react-bootstrap";
import { handleImageLink } from "@/helpers/functions";
import SvgComponent from "@/components/Shared/SvgComponent";

const TabContent = ({ data }) => {
  const { locale } = useIntl();

  return (
    <div className="registerTap">
      <Row>
        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="content">
            <div className="top">
              <div className="icon flex-center">
                <SvgComponent
                  src={handleImageLink(data?.icon)}
                  fillColor="#fc6b14"
                />
              </div>
              <h2>{data?.title?.[locale]}</h2>
            </div>
            <div className="middle">
              <p>{data?.description?.[locale]}</p>
            </div>
            {data?.link && (
              <div className="bottom">
                <Link href={data?.link}>
                  <a className="btn-md btn-md-outline">
                    <FormattedMessage id="startNow" />
                  </a>
                </Link>
              </div>
            )}
          </div>
        </Col>
        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="imageDiv flex-center">
            <Image
              src={handleImageLink(data?.image)}
              alt={data?.title?.[locale]}
              width={650}
              height={500}
              // priority
              loading="lazy"
              priority={false}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TabContent;
